import { createContext, Dispatch } from "react";
import { DateRangePeriod } from "../common";
import { Action } from "./actions";

// STATE
export interface AdminState {
    initialized: boolean,
    defaultReportDateRangePeriod: DateRangePeriod,
    eventPagesEnabled: boolean,
    pacDonationsFeatureEnabled: boolean,
    paymentPageCheckboxEnabled: boolean,
    politicalPartiesEnabled: boolean,
    subscriptionsEnabled: boolean,
    timeZone: string
    timeZoneDisplay: string,
    virtualRecipientsEnabled: boolean
    fundraisersEnabled: boolean
}

// INITIAL STATE
export const initialAdminState: AdminState = {
    initialized: false,
    defaultReportDateRangePeriod: DateRangePeriod.All,
    eventPagesEnabled: false,
    pacDonationsFeatureEnabled: false,
    paymentPageCheckboxEnabled: false,
    politicalPartiesEnabled: false,
    subscriptionsEnabled: false,
    timeZone: "",
    timeZoneDisplay: "",
    virtualRecipientsEnabled: false,
    fundraisersEnabled: false
}

// CONTEXTS
let initialAdminStateContext = { state: initialAdminState, dispatch: (action: Action) => { } }
export const AdminStateContext = createContext<{ state: AdminState, dispatch: Dispatch<Action> }>(initialAdminStateContext);